module.exports = __webpack_public_path__ + "assets/img/block-right-a36ca408.png";